<template>
  <div id="login_chat2pay">
    <div
      style="
        background-image: url('/static/img/assets/chat2pay/handle-mobile-to-pay-background.png');
        height: 100vh;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      "
    >
      <div
        style="
          position: fixed;
          z-index: 1;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          background-image: linear-gradient(to top right, #ff6868, #ffd8a4);
          background-repeat: no-repeat;
          background-size: cover;
          opacity: 0.7;
        "
      ></div>
      <div style="z-index: 2; position: relative; height: 100vh; overflow-y: auto">
        <div>
          <div class="row">
            <div class="col s12 m4 offset-m4 l4 offset-l4">
              <h1 class="text-xs-center nunito" style="text-shadow: rgba(0, 0, 0, 0.2) 0px 3px 6px">
                <span style="color: #ff706b">CHAT</span>
                <span style="color: white">2</span>
                <span style="color: #004071">PAY</span>
              </h1>
              <div style="margin-bottom: 15px; text-shadow: rgba(0, 0, 0, 0.2) 0px 3px 6px">
                <carousel
                  :items="1"
                  :autoHeight="true"
                  :nav="false"
                  :loop="true"
                  :autoplay="true"
                  :autoplayHoverPause="true"
                >
                  <div class="text-xs-center">
                    <img
                      src="/static/img/assets/chat2pay/preview-chatlog-1.png"
                      alt
                      class="responsive-img"
                      style="margin-bottom: 15px; max-width: 400px; margin: auto; padding: 15px 0px"
                    />
                    <p class="text-xs-center" style="color: white">
                      เปิดบิลผ่านแชทง่ายๆ เพียงพิมพ์หาลูกค้าว่า เปิดบิล ตามด้วยรายละเอียด และ
                      ราคาสินค้า
                    </p>
                  </div>

                  <div class="text-xs-center">
                    <img
                      src="/static/img/assets/chat2pay/preview-chatlog-2.png"
                      alt
                      class="responsive-img"
                      style="margin-bottom: 15px; max-width: 400px; margin: auto; padding: 15px 0px"
                    />
                    <p class="text-xs-center" style="color: white">
                      ระบบจะส่งลิ้งจ่ายเงินไปให้ลูกค้าทันที
                    </p>
                  </div>

                  <div class="text-xs-center">
                    <img
                      src="/static/img/assets/chat2pay/preview-chatlog-3.png"
                      alt
                      class="responsive-img"
                      style="margin-bottom: 15px; max-width: 400px; margin: auto; padding: 15px 0px"
                    />
                    <p class="text-xs-center" style="color: white">ลิ้งเดียวชำระได้ทุกช่องทาง</p>
                  </div>

                  <div class="text-xs-center">
                    <img
                      src="/static/img/assets/chat2pay/preview-chatlog-4.png"
                      alt
                      class="responsive-img"
                      style="margin-bottom: 15px; max-width: 400px; margin: auto; padding: 15px 0px"
                    />
                    <p class="text-xs-center" style="color: white">
                      ชำระบัตรเครดิต ค่าธรรมเนียม 2.9% ชำระผ่าน QR Code 0.5% เท่านั้น
                      เงินเข้าทุกวันจันทร์ พุธ ศุกร์
                    </p>
                  </div>
                </carousel>
              </div>

              <div class="text-xs-center">
                <fb-signin-button
                  class="btn btn-facebook btn-large"
                  style="border-radius: 25px; box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 6px"
                  :params="fbSignInParams"
                  @success="onSignInSuccess"
                  @error="onSignInError"
                >
                  <span class="fab fa-facebook"></span>
                  <span style="margin-left: 5px">เริ่มใช้งานด้วย Facebook</span>
                </fb-signin-button>

                <p style="margin-top: 15px; color: white; font-size: 12px">
                  หมายเหตุ: คุณต้องเป็นแอดมินของเพจ Facebook เท่านั้น
                  หากติดปัญหาการสมัครสมาชิกรบกวนโทร +66-2645-3781, +66-2248-6397-99, +6692-436-3481
                  (24 ชั่วโมง)
                </p>
              </div>
              <div class="text-xs-center" style="font-size: 10px; color: white; margin-top: 25px">
                Powered By
                <div style="margin-top: 5px">
                  <img
                    src="/static/img/assets/chat2pay/gbprime_logo.png"
                    alt
                    style="margin-right: 15px; vertical-align: middle"
                  />
                  <img
                    src="/static/img/assets/chat2pay/zwiz_logo.png"
                    alt
                    style="vertical-align: middle"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-dialog v-if="showTurnOnPermission" @close="showTurnOnPermission = false">
      <h1 slot="header" class="text-xs-center">{{ $t('Help') }}</h1>

      <div slot="body" class="text-xs-center">
        <div class="row">
          <div class="col s12">
            <p class="brand-primary">
              {{ $t('Please enable all options and try to login again') }}
            </p>

            <img
              src="/static/img/help_turn_on_permission.png"
              alt
              style="width: 100%; max-width: 500px; box-shadow: 0px 3px 6px #00000033"
            />
          </div>
        </div>
      </div>

      <div slot="footer" style="padding: 15px" class="text-xs-center">
        <a
          href="javascript:void(0);"
          class="btn btn-primary"
          @click="showTurnOnPermission = false"
          >{{ $t('cancel') }}</a
        >
      </div>
    </modal-dialog>

    <modal-dialog v-if="error" @close="error = null">
      <div class="text-xs-center" slot="body" style="margin-top: 25px">
        <div class="row" style="margin-bottom: 0">
          <div class="col s12">
            <img src="/static/img/assets/login/alert.png" alt class="responsive-img" />

            <h1>{{ $t('Error') }}</h1>
            <p>{{ error }}</p>
          </div>
        </div>
      </div>
      <div slot="footer" class="text-xs-center" style="padding: 15px">
        <a href="javascript:void(0);" class="btn btn-primary" @click="error = undefined">{{
          $t('cancel')
        }}</a>
      </div>
    </modal-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config'
import ModalHelp from '@/components/elements/ModalHelp'
import ModalDialog from '@/components/elements/ModalDialog'
import GetStarted from '@/components/view/getstarted/GetStarted'
import LangDropdown from '@/components/elements/LangDropdown'
import carousel from 'vue-owl-carousel'

window.fbAsyncInit = function () {
  // eslint-disable-next-line no-undef
  FB.init({
    appId: config.appid,
    cookie: true, // enable cookies to allow the server to access the session
    xfbml: true, // parse social plugins on this page
    version: 'v2.8'
    // auth: true
  })
}
;(function (d, s, id) {
  // eslint-disable-next-line one-var
  var js,
    fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s)
  js.id = id
  js.src = 'https://connect.facebook.net/en_US/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
})(document, 'script', 'facebook-jssdk')

export default {
  data: function () {
    return {
      userid: '',
      error: null,
      fbSignInParams: {
        scope: config.fb_scope,
        return_scopes: true
      },
      showTurnOnPermission: false,
      isGetStarted: false
    }
  },
  mounted: function () {
    var vm = this

    vm.$store.dispatch('logout', null).then(function () {})

    if (vm.$store.state.systemError && vm.$store.state.systemError.message) {
      vm.error = vm.$store.state.systemError.message
    }
    setTimeout(() => {
      vm.$nextTick(function () {
        vm.$store.commit('CLEAR_LOADING')
      })
    }, 3000)
  },
  components: {
    ModalHelp,
    ModalDialog,
    GetStarted,
    LangDropdown,
    carousel
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang'
    })
  },
  methods: {
    onSignInSuccess(response) {
      let vm = this
      if (
        !response.authResponse.grantedScopes ||
        (response.authResponse.grantedScopes &&
          (!response.authResponse.grantedScopes.includes('email') ||
            !response.authResponse.grantedScopes.includes('read_page_mailboxes') ||
            !response.authResponse.grantedScopes.includes('pages_messaging') ||
            !response.authResponse.grantedScopes.includes('public_profile') ||
            !response.authResponse.grantedScopes.includes('manage_pages') ||
            !response.authResponse.grantedScopes.includes('pages_show_list')))
      ) {
        vm.showTurnOnPermission = true
        return false
      }
      if (response.status === 'connected') {
        vm.$store
          .dispatch('loginFB', {
            accessToken: response.authResponse.accessToken,
            userid: response.authResponse.userID,
            channel: 'chat2pay',
            scope: config.fb_scope
          })
          .then(
            function () {
              if (vm.$store.getters.botlist.length === 0) {
                vm.isGetStarted = true
              } else {
                // Load language setting
                window.location.href = '/' + vm.currentLang + '/setup_c2p'
              }
            },
            function (error) {
              vm.error = error.message
            }
          )
      } else {
        vm.error = 'Unable to connect Facebook'
      }
    },
    onSignInError(error) {
      var vm = this
      vm.error = error.message
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/login/Chat2Pay.vue